import {
  getMaterialSnapshotMtrId,
} from '#/modules/crmMgmt/customerOrder/helper/mapCustomerOrderMeta';

function readCapabilityFlag(capabilities, key) {
  if (!capabilities || typeof capabilities !== 'object') {
    return undefined;
  }
  return capabilities[key];
}

/**
 * DISC-CRM-2：capabilities 未回傳時過渡期預設 true（皆顯示操作）。
 */
export function isPurchasableMaterialSnapshot(material) {
  const flag = readCapabilityFlag(material?.capabilities, 'purchasable');
  return flag !== false;
}

export function isManufacturableMaterialSnapshot(material) {
  const flag = readCapabilityFlag(material?.capabilities, 'manufacturable');
  return flag !== false;
}

/** `mtr.id` 優先；fallback 舊扁平 `mtrId`。 */
export function resolveMaterialSnapshotMtrId(material) {
  return getMaterialSnapshotMtrId(material);
}
